import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import striptags from "striptags";
import { FunctionFactory, Model } from "survey-core";
// Register the Czech localization for built-in messages (e.g. mask "invalidInputError")
import "survey-core/i18n/czech";
// import "survey-core/survey-core.min.css";
import SurveyTheme from "survey-core/themes";
import { Survey } from "survey-react-ui";
/**
 * SurveyForm component renders a SurveyJS form based on the provided definition and data.
 *
 * Note: it's not production-ready and should be refined further before using in a real application.
 * Also, we need to move code of shared components to a separate reusable package.
 *
 * @see https://surveyjs.io/
 */
export function SurveyForm({ onSubmit, definition, data, theme, styles, css, customClasses, validators, }) {
    // TODO: find alternative way to keep working SSR correctly
    // The SurveyForm has been converted to a client-side component to avoid hydration errors.
    // The survey-core have Base.UniqueId and BaseAction.renderedId under the hood,
    // which causes different parameters to be generated on the client and server
    const [hydrated, setHydrated] = useState(false);
    useEffect(() => {
        setHydrated(true);
    }, []);
    if (!hydrated) {
        return (_jsxs(_Fragment, { children: [_jsx("style", { children: css || "" }), _jsx("div", { className: "lg-form-placeholder", style: { minHeight: "600px" }, "aria-hidden": "true" })] }));
    }
    const survey = new Model(definition || {});
    survey.onTextMarkdown.add((_, options) => {
        options.html = striptags(options.text)
            // **bold**
            .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
            // *italic*
            .replace(/\*(.*?)\*/g, "<i>$1</i>")
            // links: [text](url)
            .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>');
    });
    survey.applyTheme(styles ? styles : theme ? SurveyTheme[theme] : SurveyTheme.LayeredLight);
    if (data) {
        survey.mergeData(data);
    }
    if (customClasses) {
        survey.onUpdateQuestionCssClasses.add(function (_, options) {
            const classes = options.cssClasses;
            const customClass = customClasses[options.question.name];
            if (customClass) {
                classes.root = `${classes.root || ""} ${customClass}`.trim();
            }
        });
    }
    survey.onComplete.add((sender, _) => {
        if (onSubmit) {
            onSubmit(sender.data);
        }
    });
    if (validators) {
        Object.entries(validators).forEach(([name, v]) => {
            //TODO: check for memory leaks when repeatedly mounting/unmounting components with custom validators:
            FunctionFactory.Instance.register(name, v.func, Boolean(v.isAsync));
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: css || "" }), _jsx(Survey, { model: survey })] }));
}
